module.exports = __webpack_public_path__ + "img/8.eade1382.png";